import { ApiClient } from '@/lib/axios/client';
import type { GuideEntry } from './types';

const BASE_PATH = '/api/v1/ai/guide';

export class AIGuideApi {
  /** Every guide entry, without bodies */
  static async listEntries(): Promise<GuideEntry[]> {
    return await ApiClient.get<GuideEntry[]>(BASE_PATH);
  }

  /** One entry with its Markdown body */
  static async getEntry(entryId: string): Promise<GuideEntry> {
    return await ApiClient.get<GuideEntry>(`${BASE_PATH}/${encodeURIComponent(entryId)}`);
  }
}
